// extracted by mini-css-extract-plugin
module.exports = {"sideBarTitle":"Title_sideBarTitle__1e2St","primary":"Title_primary__2EjDt","caret":"Title_caret__rPC9c","open":"Title_open__2UgvP"};